import React from 'react'

interface Props {
  subject: 'event' | 'listing'
  subjectId: string
}

const EventActions: React.FC<Props> = ({ subject, subjectId }) => {
  const reportIssue = () => {
    const message = window.prompt('Describe the issue')
    if (!message) return
    const log = { id: `${Date.now()}`, subject, subjectId, message, createdAt: new Date().toISOString() }
    const raw = localStorage.getItem('reports')
    const arr = raw ? JSON.parse(raw) : []
    arr.push(log)
    localStorage.setItem('reports', JSON.stringify(arr))
    alert('Thanks! We\'ll review this report.')
  }
  const rsvp = () => {
    const raw = localStorage.getItem('rsvps')
    const arr = raw ? JSON.parse(raw) : []
    const exists = arr.find((x: any) => x.subjectId === subjectId && x.subject === subject)
    if (exists) {
      localStorage.setItem('rsvps', JSON.stringify(arr.filter((x: any) => !(x.subjectId === subjectId && x.subject === subject))))
      alert('RSVP removed.')
    } else {
      arr.push({ subject, subjectId, at: new Date().toISOString() })
      localStorage.setItem('rsvps', JSON.stringify(arr))
      alert('RSVP saved!')
    }
  }
  return (
    <div className="flex gap-2">
      <button className="btn-primary" onClick={rsvp}>RSVP</button>
      <button className="btn-secondary" onClick={reportIssue}>Report Issue</button>
    </div>
  )
}

export default EventActions

